// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1hUID","detailsBorder":"styles_detailsBorder__tp8BE"};